import { Component, OnInit } from '@angular/core';
import { FaqService } from '../typewriter/output/FaqController';
import { FaqDto } from '../typewriter/output/FaqDto';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  query: Observable<any>;
  faqs: FaqDto[];

  constructor(
    private faqService: FaqService
  ) { }

  ngOnInit() {
    this.query = Observable.fromPromise(
      this.faqService.get()
        .then(response => {
          this.faqs = response;
        })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/faq/faq.component.ts